var Reverb = window.Reverb || {};
Reverb.Listing = Reverb.Listing || {};

Reverb.Listing.ProductTypeChange = (function () {
  function handleProductTypeChange() {
    // Dynamically load product type custom attributes
    var productTypeSelect = $('#product_product_type_id');
    var product_id = $('#product').data('id');

    productTypeSelect.change(function () {
      var formField = $(this);
      var fieldsWrapper = $('#product_type_attributes_wrapper');
      var spinnerContainer = $('[data-spin=product-type-change]');

      var product_type_id = $.trim(formField.val());
      if (product_type_id) {
        spinnerContainer.spin();
        $.get(formField.attr('rel'), { product_id: product_id, product_type_id: product_type_id }, function (response) {
          fieldsWrapper.html(response);
          spinnerContainer.stopSpinner();
        }).fail(function () {
          fieldsWrapper.html('');
        });
      } else {
        fieldsWrapper.html('');
      }
    });

    productTypeSelect.change();
  }

  function init() {
    handleProductTypeChange();
  }

  return {
    init: init
  };
})();

$(document).ready(Reverb.Listing.ProductTypeChange.init);



// WEBPACK FOOTER //
// ./javascripts/components/legacy/listing/product_type_change.js